import React from "react";
import styled from "styled-components";

import InputSectionBackgroundImg from "../../images/background6.jpg"

import GitInput from "../../Components/gitInput/index"

const InputSectionContainer = styled.div`
	width: 100%;
	height: 750px;
	background: url(${InputSectionBackgroundImg});
	background-size: cover;
`;

const TopSectionInnerContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
`;

export function InputSection(props){
	return <InputSectionContainer id="inputsect">
	<TopSectionInnerContainer>
	<GitInput />
	</TopSectionInnerContainer>
	</InputSectionContainer>
} 
